<template>
    <div>

        <v-alert v-if="items.length===0" color="info" class="body-2 mt-6 ma-3" icon="mdi-information">
            No announcements found.
        </v-alert>

        <v-card
                raised
                dark
                v-for="item in items"
                :key="items.id"
                class="ma-3"
                color="grey darken-2"
        >
            <v-card-text>

                <v-card color="primary">

                    <v-alert type="info" prominent dense>
                        <h3>Announcement!</h3>
                    </v-alert>

                </v-card>

                <div class="pt-3">
                    <vue-markdown :source="item.body" :show="true">
                    </vue-markdown>
                </div>

                <div class="caption pt-3">
                    Received {{ toHumanFrom(item.created_at) }}
                </div>

            </v-card-text>

            <v-card-actions>
                <v-btn v-if="item.action_text" ripple small @click="goToUrl(item.action_url)" color="primary">
                    {{item.action_text }}
                </v-btn>
                <v-btn text @click="dismissClicked(item.id)">Dismiss</v-btn>
            </v-card-actions>

        </v-card>

    </div>

</template>

<script>

    import {timeDisplay} from '../../../components/mixins/timeDisplayMixin';
    import VueMarkdown from '@adapttive/vue-markdown';

    export default {

        mixins: [timeDisplay],

        components: {
            VueMarkdown
        },

        props: {
            items: {
                type: Array,
                required: true
            }
        },

        methods: {
            goToUrl(url) {
                this.$router.push(url);
            },
            dismissClicked(id) {
                this.$store.dispatch('markMessagesRead', [id]);
            }
        },
    };

</script>
